import { DatePicker } from 'antd';
import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
React.useLayoutEffect = React.useEffect 

// import InputNumber from '../../../components/Input/InputNumber';
// import PopupWarning from '../../../components/ProductList/PopupWarning'; 
// import LayoutComponent from '../../../components/layout';

// import Tab from '../../../components/Tab/tab';
import environment from '../../../utils/environment';
import { checkUndefinedNumber, currencyWithNoFormat } from '../../../utils/format';
import { getProductBundling, getProductList } from '../../api/hello';
import { getProductDetailByPdm, getProductDetailByUrl, getProductDetailCombo, getRefreshStockingCount, getStockByUrl } from '../../api/product';
import { IOrderType } from '../../../@types/IProductList';
import { addToCart, calSurchargeDay, mapToGtag_ProductDetail } from '../../../utils/payment';
import { STORAGE_KEYS } from '../../../utils/config';

import dayjs from "dayjs";
import VideoPlayer from '../../../components/VideoPlayer';
import { toast } from 'react-hot-toast';
import { useRouter } from 'next/router';
import PaymentContext from "../../../store/PaymentContext";
import React from 'react';
import { handleAccessories, hasToIncreaseTotalAmount, maxTotalAmount } from '../../../components/ProductList/utils';
import { addKeyToImage, chkUrl, getMetaImg_Product, imageAlt, imageLoader } from '../../../utils/utils';
// import HeadComponent from '../../../components/layout/Head';
import AppContext from '../../../store/AppContext';
import { onChangeAttrTab } from '../../../components/Tab/utils';
import dynamic from 'next/dynamic';
import { event } from "nextjs-google-analytics";
import { usePathname } from 'next/navigation';
import { IBreadcrumbList, IImageObject, IProduct, IWebPage } from '../../../components/gSnippet/interface';
import { generateGSnippet } from '../../../components/gSnippet';
const DynamicHeadComponent = dynamic(() => import('../../../components/layout/Head'));
// const DynamicHeadComponent = dynamic(() => import('../../../components/layout/Head'));
// const DynamicAttachedItem = dynamic(() => import('../../../components/AttachedItem'));
const DynamicAttributeValuesRender = dynamic(() => import('../../../components/AttributeValues'));
const DynamicList_keyword = dynamic(() => import('../../../components/Keyword'));
const Item = dynamic(() => import('../../../components/ProductList/ProductItem'));
const Tab = dynamic(() => import('../../../components/Tab/tab'));
const Information_Product_Tab = dynamic(() => import('../../../components/Tab/information_product_tab'));
const PopupOrder = dynamic(() => import('../../../components/PopupOrder'));
const PopupSizeGuide = dynamic(() => import('../../../components/PopupSizeGuide'));
const PopupSignup = dynamic(() => import('../../../components/PopupSignup'));
const DynamicLayoutComponent = dynamic(() => import('../../../components/layout'));
const DynamicDescriptionTab = dynamic(() => import('../../../components/Tab/description_tab'));
const DynamicInputNumber = dynamic(() => import('../../../components/Input/InputNumber'));
const DynamicPopupWarning = dynamic(() => import('../../../components/ProductList/PopupWarning'));

const Slider = dynamic(() => import('react-slick'), { ssr: false });
// import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Product = ({seo}:any) => {
    const imgRef:any = useRef(null);
    const [count, setCount] = useState(0);
    // const [isSeeCombo, setIsSeeCombo] = useState(false);
    // const [isSeeAttach, setIsSeeAttach] = useState(false);
    const router = useRouter();
    // const [openMaintain, setOpenMaintain] = useState(false);
    const { branchs, windowWidth, holidays, workingDay, attachItems, comboAttachItems, setAttachItems, setComboAttachItems } = useContext(AppContext);
    const [loading, setLoading] = useState(true);
    const [loadingEnd, setLoadingEnd] = useState(true);
    const [loadingStock, setLoadingStock] = useState(true);
    const [loadingAttached, setLoadingAttached] = useState(true);
    const [isAllowAction, setIsAllowAction] = useState(false);
    const [isAllowActionRent, setIsAllowActionRent] = useState(false);
    // const [host, setHost] = useState("");
    const [url, setUrl]: any = useState('');
    const { setSellCarts, setRentCarts, sellCarts, rentCarts } = useContext(PaymentContext);
    const [activeImage, setActiveImage] = useState<number>(0);
    const [thumbnailVideo, setThumbnailVideo] = useState<any>(null);
    // const [hasInnerText, setHasInnerText] = useState(true);
    // const [additional, setAdditional] = useState({
    //     id: "",
    //     name: "",
    //     groupName: ""
    // });

    const [detail, setDetail]: any = useState<any>();
    const [phaseMobile, setPhaseMobile] = useState(-1);
    const [isMobile, setIsMobile] = useState(false);
    const [activeTabShop, setActiveTabShop] = useState<number>(0);
    const [similarItems, setSimilarItems] = useState([]);
    // const [selectBranch, setSelectBranch]: any = useState(null);
    const [openSignUp, setOpenSignUp] = useState(false);
    const [date, setDate]: any = useState({
        takeDate: null,
        returnDate: null
    });
    const [openWarning, setOpenWarning] = useState(false);
    // const [_seo, _setSeo] = useState(seo);
    const [isOpen, setIsOpen] = useState<{ isOpen: boolean, orderType: number, is_purchase: boolean | any, id: number | any, isOthers: boolean, is_product: boolean, url_product:string }>({
        isOpen: false,
        orderType: 0,
        is_purchase: null,
        id: null,
        isOthers: true,
        is_product: true,
        url_product: ""
    });
    // const [content, setContent] = useState(null);
    // const [numberStore, setNumberStore] = useState(1);
    useEffect(() => {
        loadUrl();
    }, [router]);

    const loadUrl = async () => {
        //const urlRequest: any = await getUrls() ?? [];
        const slug = router.query.slug as string[]
        const convertUrlToSlug: string = await slug?.length > 1 ? `/${slug.join('/')}` : `/${slug}`
        // const getLinkPage = await urlRequest.findIndex((link: any) => link.url === `/san-pham${convertUrlToSlug}`)
        setUrl(`${convertUrlToSlug}`)
    }

    const [isOpenSizeGuide, setIsOpenSizeGuide] = useState(false);
    const [isRentRule, setIsRentRule] = useState(false);
    const [arr_attr_view, setArr_attr_view] = useState([]);

    // function setAdditionalId(id: any, name: any) {
    //     setAdditional({
    //         ...additional,
    //         id: id,
    //         name: name,
    //     })
    // }

    const handleAddToCartSell = () => {
        try{
            if (!isAllowAction && !localStorage.getItem(STORAGE_KEYS.showWarningCombo)) {
                setOpenWarning(true);
            }
            handleAddToCart(true);
            return true;
        }
        catch(ex){
            return false;
        }
        
    }

    const handleAddToCartRent = () => {
        try{
            if (!date || !date?.takeDate || !date?.returnDate) {
                toast.error("Vui lòng chọn ngày lấy và ngày trả");
                return;
            }
            if (!isAllowAction && !localStorage.getItem(STORAGE_KEYS.showWarningCombo)) {
                setOpenWarning(true);
            }
            // addToCart(
            //     sellCarts,
            //     rentCarts,
            //     setRentCarts,
            //     rentCarts,
            //     {
            //         ...detail.selectProductDetail,
            //         attribute_values: detail.attributeValues,
            //         take_date: date?.takeDate,
            //         return_date: date?.returnDate,
            //         temp_accessories: detail.accessories,
            //         attribute_choose: detail.selectProductDetail.attribute_values,
            //         files: detail.data.files,
            //         name: detail.data?.name,
            //     },
            //     false,
            //     detail.totalAmount
            // );
            handleAddToCart(false);
            return true;
        }
        catch(ex){
            return false;
        }
    }

    function onCheckAlreadySignUp() {
        setOpenSignUp(true);
        scrollTabShop();
        // let name = localStorage.getItem(STORAGE_KEYS.name);
        // let email = localStorage.getItem(STORAGE_KEYS.email);
        // let phone = localStorage.getItem(STORAGE_KEYS.phone);
        // console.log(name, phone);
        // if (!name || !phone) {

        //     setOpenSignUp(true);
        //     return false
        // } 
        // return false
    }

    const handleAddToCart = (isSell: boolean | null) => {
        let isValid = true;
        if (detail?.data?.is_product === false) {
            detail.accessories?.map((e: any) => {
                if (e.count > e.amount) {
                    isValid = false
                }
                return e;
            })
        }
        if (isValid) {
            addToCart(
                workingDay,
                holidays,
                sellCarts,
                rentCarts,
                isSell ? setSellCarts : setRentCarts,
                isSell ? sellCarts : rentCarts,
                {
                    ...detail.selectProductDetail,
                    attribute_values: detail.attributeValues,
                    take_date: date?.takeDate,
                    return_date: date?.returnDate,
                    temp_accessories: detail.accessories,
                    attribute_choose: detail.selectProductDetail.attribute_values,
                    files: detail.data.files,
                },
                isSell,
                detail.totalAmount
            );
        } else {
            toast.error("Số lượng sản phẩm không khả dụng");
        }
    }

    function updatePrice(data: any) {
        let cloneProductDetails = detail.data?.product_details?.map((d: any) => {
            let findProductDetail = data.product_details?.find((e: any) => e.product_code === d.product_code);
            //console.log('findProductDetail', findProductDetail);

            if (findProductDetail) {
                d.product_code = findProductDetail.product_code;
                d.code = findProductDetail.code;
                d.name = findProductDetail.name;
                d.amount = findProductDetail.amount;
                d.price = findProductDetail.price;
                d.rental_price = findProductDetail.rental_price;
                d.attribute = findProductDetail.attribute;
            }
            return d;
        })
        let product_detail = { ...detail.selectProductDetail };
        let accessories = [];
        if (detail.data?.is_product === false) {
            accessories = cloneProductDetails?.map((item: any) => {
                //count giá trị cho input
                item.count = item.product_amount ?? 0;
                return item;
            }) ?? [];
            product_detail = {
                ...detail.selectProductDetail,
                //product_code: data.product_code,
                rental_price: data.rental_price,
                price: data.price,
                amount: data.amount
            }
        } else {
            let currentSelectProductDetail = cloneProductDetails?.find((e: any) => e.product_code === detail.selectProductDetail?.product_code);
            accessories = handleAccessories(currentSelectProductDetail) ?? [];
            product_detail = {
                ...detail.selectProductDetail,
                //product_code: currentSelectProductDetail.product_code,
                rental_price: currentSelectProductDetail.rental_price,
                price: currentSelectProductDetail.price,
                amount: currentSelectProductDetail.amount
            }
        }
        //console.log('cloneProductDetails', cloneProductDetails);
        //console.log('accessories', accessories);

        let cloneDetail = {
            ...detail,
            data: {
                ...detail.data,
                origin_price: data.origin_price,
                origin_rental_price: data.origin_rental_price,
                price: data.price,
                rental_price: data.rental_price,
                amount: data.amount,
                product_details: cloneProductDetails,
            },
            selectProductDetail: product_detail ?? null,
            accessories: accessories,
            totalAmount: detail.data?.is_product === false ? (detail.data?.amount > 0 ? 1 : 1) : (checkAvailableTotalAmount(product_detail) ? 1 : 1),

        }
        return cloneDetail;
    }

    async function onChangeAttribute(main_id: any, attr: any) {
        let accessories = onChangeAttrTab(detail?.accessories, main_id, attr);
        await callUpdatePrice(accessories, date);
    }

    async function callUpdatePrice(accessories: any, date: any) {
        let data: any = {
            product_mix_id: detail?.data.id,
            products: accessories?.map((acc: any) => {
                return {
                    product_code: acc.product_code,
                    attribute_main_id: acc.attribute_main_value_id,
                    attributes: acc.attribute?.map((attr: any) => attr.value)
                };
            }),

        }
        if (date.takeDate && date.returnDate) {
            data.from_date = date?.takeDate ? moment(date?.takeDate).format("DD/MM/YYYY HH:mm:ss") : "";
            data.to_date = date?.returnDate ? moment(date?.returnDate).format("DD/MM/YYYY HH:mm:ss") : "";
        }
        let res = await getProductDetailByPdm(data);
        if (res) {
            let cloneDetail = updatePrice(res);

            await setDetail(cloneDetail);
            checkAllowActionSell();
            checkAllowActionRent();
        }
    }

    

    // const RenderTab = ({ detail, activeTab }: any) => {
    //     if(detail){
    //         console.log(detail);
    //         let isHideSP = (detail?.data?.is_product === false ? false : detail?.selectProductDetail?.is_set === false);
    //         let chkDescription = (detail?.data?.description);
    //         let chkActiveTab = ((isHideSP && !chkDescription) ? 2 : (isHideSP && chkDescription) ? 1 : 0); // 0: Product; 1: Description; 2: shop
    //         if(activeTab >= 0){
    //             chkActiveTab = activeTab;
    //         }else{
    //             setActiveTab(chkActiveTab);
    //         }
            
    //         let shopTab = <ShopTab detail={detail} date={date} moment={moment} hidden={chkActiveTab!==2} key={"shopTap"} is_Product={detail?.data?.is_product}/>
    //         let description = <DescriptionTab content={detail?.data?.description ?? ""} key={"contentTab"} hidden={chkActiveTab!==1}/>;
    //         let product = <ProductTab
    //                         is_product={detail?.data?.is_product}
    //                         onChange={onChangeAccessorieAmount}
    //                         attribute={detail?.data?.attribute}
    //                         accessories={detail?.accessories}
    //                         handleChangeActive={onChangeAttribute}
    //                         key={"productTab"} hidden={chkActiveTab!==0}/>;
    //         let list = [
    //             product,
    //             description,
    //             shopTab
    //         ];
            
    
    //         // if (detail?.selectProductDetail?.is_set === false) {
    //         //     list = [
    //         //         description,
    //         //         shopTab
    //         //     ];
    //         //     number = activeTab = 1;
    //         //     //TH sản phẩm phối
    //         //     if (detail?.data?.is_product === false) {
    
    //         //         list = [
    //         //             product,
    //         //             description,
    //         //             shopTab
    //         //         ];
    //         //         number = 2;
    
    //         //         if (!detail?.data?.description) {
    //         //             list = [
    //         //                 product,
    //         //                 shopTab
    //         //             ]
    //         //             number = 1;
    //         //         }
    //         //         activeTab = 0;
    //         //     }
    
    //         //     if (!detail?.data?.description && detail?.data?.is_product === true) {
    //         //         list = [
    //         //             shopTab
    //         //         ]
    //         //         number = 0;
    //         //         activeTab = 2;
    //         //     }
    //         // } else if (!detail?.data?.description) {
    //         //     list = [
    //         //         product,
    //         //         shopTab
    //         //     ];
    //         //     number = 1;
    //         //     activeTab = 0;
    //         // }
            

    //         // return list[activeTab] ?? <></>
    //         return list;
    //     }
    //     return <></>
    // }

    function closePopup() {
        setIsOpen({
            ...isOpen,
            isOpen: false,
            is_purchase: null,
        })
    }

    // async function onTryOnSchedule() {
    //     try {
    //         let data = {
    //             id: detail.selectProductDetail?.id,
    //             customer: {
    //                 name: localStorage.getItem(STORAGE_KEYS.name),
    //                 phone: localStorage.getItem(STORAGE_KEYS.phone),
    //                 email: localStorage.getItem(STORAGE_KEYS.email),
    //             },
    //             try_on_date: date?.takeDate,
    //             branch_id: selectBranch,
    //             product_detail_code: detail?.selectProductDetail?.code,
    //             product_accessories: detail?.accessories
    //         };
    //         let res = await postTryOnSchedule(data);
    //         if (res) {

    //         }
    //     } catch (error) {

    //     }
    // }


    function renderImageCombo(data:any){
        return data.map((x:any) => {
            if(x?.files?.length && x?.files[0]?.image_url){
                x.file = {
                    image_id: x?.files[0].image_id,
                    image_name: x?.files[0].image_name,
                    image_size: x?.files[0].image_size,
                    image_type: x?.files[0].image_type,
                    image_url: x?.files[0].image_url,
                    alt: x?.files[0].alt,
                }
            }
            return {
                ...x
            }
        })
    }

    async function getRefreshStocking() {
        let product_code = detail?.selectProductDetail?.code ?? "";
        let from_date = date?.takeDate ? moment(date?.takeDate).format("DD/MM/YYYY HH:mm:ss") : "";
        let to_date = date?.returnDate ? moment(date?.returnDate).format("DD/MM/YYYY HH:mm:ss") : "";
        // let cb_new = [...comboAttachItems];
        // if(cb_new.length === 0 &&  detail?.data?.is_product !== false){
        //     let res: any = await getProductDetailCombo(detail?.selectProductDetail?.code ?? "");
        //     if (res) {
        //         cb_new = await res?.results;
        //         setComboAttachItems(cb_new);
        //     }
        // }
        // console.log(cb_new);
        let data: any = comboAttachItems?.map((item: any, index: number) => {
            return {
                product_code: item.code,
                index: index,
                order_id: null,
                is_mix: true,
                amount: 0,
                from_date: null,
                product_details: item?.product_details?.map((e: any) => e.code)
            }
        });

        let product_details = detail?.data?.product_details?.map((e: any) => e.code);

        if (product_code !== "") {
            // setLoading(true)
            let res: any = await getRefreshStockingCount(detail?.data.is_product === false ? detail.data.code : product_code, product_details ? product_details.join(",") : "", from_date, to_date, !detail?.data.is_product, detail?.totalAmount, data);
            if (res) {

                if (detail?.data.is_product === false) {
                    let cloneDataDetail = { ...detail.data };
                    let cloneAccessories = [...detail.accessories];
                    cloneDataDetail.amount = res?.in_stock;
                    cloneAccessories = cloneAccessories?.map((item: any) => {
                        item.amount = res.accessories[item.code] ?? item.amount;
                        return item;
                    })

                    await setDetail({
                        ...detail,
                        data: cloneDataDetail,
                        accessories: cloneAccessories
                    })
                } else {
                    let cloneNewSelectProductDetail = { ...detail.selectProductDetail };
                    cloneNewSelectProductDetail.accessories = cloneNewSelectProductDetail?.accessories?.map((item: any) => {
                        if (res.accessories) {
                            item.amount = res?.accessories[item.code] ?? res?.in_stock ?? item.amount;
                        }

                        return item;
                    });
                    // if (res.in_stock) {
                        detail.selectProductDetail.amount = res?.in_stock;
                    // }
                    await setDetail({
                        ...detail,
                        accessories: cloneNewSelectProductDetail.accessories
                    })
                }
                setComboAttachItems([...comboAttachItems.map((item: any) => {
                    let related_item = res.related_products?.find((e: any) => item.code === e.product_code);
                    if (related_item) {
                        item.amount = related_item.in_stock;
                        item.product_details = [...item.product_details]?.map((product: any) => {
                            product.amount = related_item?.accessories[product.code]
                            return product;
                        })
                    }

                    return item;
                })]);
                checkAllowActionSell();
                checkAllowActionRent();
            }
            // setLoading(false)
        }

    }

    function openSellPopup(id: any, is_product: boolean, url_product: string) {
        setIsOpen({
            ...isOpen,
            isOpen: true,
            orderType: IOrderType.sell,
            is_purchase: true,
            is_product: is_product,
            id: id,
            url_product: url_product
        })
    }

    function openRentPopup(id: any, is_product: boolean, url_product: string) {
        setIsOpen({
            ...isOpen,
            isOpen: true,
            orderType: IOrderType.rent,
            is_purchase: false,
            is_product: is_product,
            id: id,
            url_product: url_product
        })
    }

    function openOrderTrialPopup(id: any) {
        setIsOpen({
            ...isOpen,
            isOpen: true,
            orderType: IOrderType.orderCalendar,
            id: id,
            is_product: true
        })
    }

    const [gSnippet, setGSnippet] = useState(null);
    const router_path = usePathname();
    const gSnippetLoad = async (product:any, totalAmount: number) => {
        try{
            let now = moment().toISOString();
            let _dateCreated = product?.data?.created_date ? product?.data?.created_date : now;
            let _dateModified = product?.data?.modified_date ? product?.data?.modified_date : now;

            let webPage:IWebPage = {
                name: seo?.title,
                description: seo?.description,
                dateCreated: "",
                dateModified: "",
                primaryImageOfPage: "",
                keyword: seo?.keyword
            }
            let imageObject:IImageObject = {};
            let _product:IProduct = {};
            let _breadcrumb:Array<IBreadcrumbList> = [
                {
                    name: "Sản phẩm",
                    url: "/san-pham",
                }
            ];
            
            if(product){
                let image_url = (product?.data?.files && product?.data?.files[activeImage]?.file_url ? environment.baseImageUrl + product?.data?.files[activeImage]?.file_url : process.env.SITE_URL + "asset/image/No_Image_Available_1.webp");
            
                webPage.primaryImageOfPage = image_url;
                webPage.dateCreated = _dateCreated;
                webPage.dateModified = _dateModified;
            
                imageObject = {
                    url_img: image_url,
                    caption: imageAlt(product?.data?.files[activeImage]?.alt, product?.data?.name),
                }

                let arr_image = product?.data?.files?.map((item: any) => {
                    return (item && item?.file_url ? environment.baseImageUrl + item?.file_url : process.env.SITE_URL + "asset/image/No_Image_Available_1.webp")
                })

                let _category = "";
                {
                    product?.data?.group_url?.map((e: any) => {
                        _category += e.name + ",";
                        _breadcrumb.push({
                            name: e.name,
                            url: e?.url
                        });
                    })
                }
                _product = {
                    name: product?.data?.name,
                    url_img: image_url,
                    description: seo?.description,
                    dateCreated: _dateCreated,
                    dateModified: _dateModified,
                    category: _category.length > 0 ? _category.slice(0, -1) : _category,
                    arr_image: arr_image,
                    price: product?.selectProductDetail?.price,
                    priceRent: (product?.selectProductDetail?.rental_price && product?.selectProductDetail?.rental_price > 0 
                                    ? product?.selectProductDetail?.rental_price : ""),
                    totalAmount: totalAmount
                }
            }
            let gSnippet = await generateGSnippet(router_path, webPage, imageObject, _breadcrumb, {}, _product);
            await setGSnippet(gSnippet);
        }catch(e){
            console.log(e);
        }
    }
    async function loadProductDetail() {
        try {
            if (url) {
                setLoading(true);
                setLoadingEnd(true);
                // setContent(null);
                setSimilarItems([]);
                setAttachItems([]);
                setComboAttachItems([]);
                setActiveImage(0)

                let res: any = await getProductDetailByUrl(url);
                //is_product = false: sản phẩm phối
                if (res) {
                    // let check_url = res.check_url;
                    // if(typeof check_url === 'object' && !check_url.is_main){
                    //     window.location.href = check_url.url;
                    // }
                    
                    let product_detail = { ...res?.product_details[0], name: res?.product_details[0]?.name, is_product: res?.is_product ?? true };

                    // let accessories = [];
                    // //TH sản phẩm phối
                    // if (res?.is_product === false) {
                    //     accessories = res?.product_details?.map((item: any) => {
                    //         //count giá trị cho input
                    //         item.count = item.product_amount ?? 0;
                    //         return item;
                    //     }) ?? [];
                    //     product_detail = { ...product_detail, allowed_sell: res.allowed_sell, id: res?.id, temp_code: product_detail.code, code: res?.code, accessories: accessories, is_product: false, name: res.name, rental_price: res.rental_price, price: res.price, origin_rental_price: res.origin_rental_price, origin_price: res.origin_price }
                    // } else {
                    //     accessories = handleAccessories(product_detail) ?? [];
                    // }

                    let attr_view:any = [];
                    res.attribute_values_view?.map((e: any, indexPar: number) => e.values?.map((item: any, index: number) => {
                        if(item.key)
                            attr_view.push(item.key);
                    }))

                    await setArr_attr_view(attr_view);
                    let _detail = {
                        data: res,
                        // attributeValues: arr_attr,
                        selectProductDetail: product_detail ?? null,
                        // accessories: accessories,
                        // totalAmount: res.is_product === false ? (res.amount > 0 ? 1 : 1) : (checkAvailableTotalAmount(product_detail) ? 1 : 1),
                        totalRentPrice: 0,
                        totalSellPrice: 0,
                        surchargeDate: 0,
                    }
                    
                    await setDetail(_detail);
                    if(res?.youtube_url){
                        let thumbnail = {
                            default: "/asset/image/No_Image_Available.webp",
                            min: "/asset/image/No_Image_Available.webp",
                            heightDefault: 500
                        }
                        let thumbnail_url = res.thumbnail_url ? res.thumbnail_url : res.files[0]?.file_url;
                        if(thumbnail_url){
                            let url_def = environment.baseImageUrl + res.files[0]?.file_url;
                            let imageSize:any = await getMetaImg_Product(environment.baseImageUrl, res.files[0]?.file_url, window.innerWidth);
                            console.log("imageSize: ", imageSize);
                            thumbnail = {
                                default: environment.baseImageUrl + addKeyToImage(thumbnail_url, 0, (window.innerWidth >= 700), (window.innerWidth < 700), false, false),
                                min: environment.baseImageUrl + addKeyToImage(thumbnail_url, 0, false, false, true, false),
                                heightDefault: imageSize
                            }
                        }
                        await setThumbnailVideo(thumbnail);
                        await setActiveImage(-1)
                    }
                    setLoading(false);
                    if((window.innerWidth > 700)){
                        loadStock(_detail);
                    }
                    
                    
                    
                    // let res_Inventory: any = await getInventoryProductDetailByCode(product_detail.code);
                    // if(res_Inventory){
                    //     setStockBranch(res_Inventory);
                    // }
                    
                    event("view_item", mapToGtag_ProductDetail({
                        id: product_detail.id,
                        name: product_detail.name,
                        price: product_detail.price
                    }));
                }
            }
        } catch (error) {
            setLoading(false);
        }

    }


    async function getCombo(detail:any) {
        try {
            setLoadingAttached(true);
            //Ẩn 2 api cho production
            let res: any = await getProductBundling(`code=${detail?.data?.is_product === true ? detail?.selectProductDetail?.code : detail?.data.code}&limit=6&page=1${detail?.data?.is_product === false ? '&is_mix=true' : ''}`);

            if (res && res.results && res.results.length > 0) {
                // for(let i =0; i< 10; i++){
                //     temp.push(res?.results[0]);
                // }
                let count_prod = 2; 
                if(res.results.length == 1){
                    count_prod = 1;
                }
                await setAttachItems(renderImageCombo(res.results));
                setSettingsAttached({
                    dots: false,
                    infinite: false,
                    speed: 500,
                    autoplay: false,
                    autoplaySpeed: 2000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                        {
                          breakpoint: 800,
                          settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            initialSlide: 1
                          }
                        },
                        {
                          breakpoint: 480,
                          settings: {
                            slidesToShow: count_prod,
                            slidesToScroll: 1
                          }
                        }
                      ]
                });
                
                // setIsSeeAttach(true);
            }

            res = await getProductDetailCombo(detail?.selectProductDetail?.code ?? "");

            if (res && res.results && res.results.length > 0) {
                await setComboAttachItems(renderImageCombo(res.results))
                // setIsSeeCombo(true);
            }
            // setTimeout(function(){
            //     //==== Đợi load sp bán kèm xong mới hiện content ra để tránh đánh giá CLS của Google
            //     setContent(detail.data.content);
            // }, 200);
            if(res)
                setTimeout(function(){
                    loadSimilar(res.is_product, res.id, detail?.selectProductDetail.group_id, detail?.selectProductDetail.id);
                }, 600);
            await setLoadingAttached(false);

        } catch (error) {

        }
    }

    // useEffect(function(){
    //     if(loadingStock && detail?.data)
    //         loadStock();
    // }, [loadingStock, detail?.data]);

    async function loadStock(_detail:any=null) {
        setLoadingStock(true);
        let accessories = [];
        let detail = {..._detail};
        let product_detail = {...detail.selectProductDetail};
        //is_product = false: sản phẩm phối
        //TH sản phẩm thường
        let item_active_id:any = null;
        if(detail.data?.is_product==true){
            let res_stock: any = await getStockByUrl(url);
            if (res_stock && res_stock.product_details && res_stock.product_details.length == detail.data.product_details.length) {
                await detail.data.product_details.map((x:any)=>{
                    let item_temp = res_stock.product_details.find((y:any) => y.code == x.code);
                    if(item_temp){
                        x["amount"] = item_temp.amount;
                        if(x?.accessories && x?.accessories.length > 0){
                            x?.accessories.map((z:any) => {
                                let accessories_child = item_temp.accessories.find((w:any) => w.code == z.code);
                                if(accessories_child){
                                    z.amount = accessories_child.amount
                                }
                            })
                        }
                        if(item_temp.amount > 0 && !item_active_id){
                            item_active_id = {...x};
                        }
                        
                        // temp["accessories"] = item_temp.accessories;
                    }
                    return x;
                })
            }
        }
        product_detail = { ...detail.data.product_details[0], name: detail.data.product_details[0]?.name, is_product: detail.data?.is_product ?? true };
        
        // === Xử lý Active và kiểm tra tồn kho của thuộc tính
        let arr_attr = [];
        
        if(detail.data.attribute_values && detail.data.attribute_values.length > 0){
            arr_attr = detail.data.attribute_values.map((obj:any, i:any) => {
                let flag = false;
                obj.values.map((obj_val:any, ix:any) => {
                    obj_val["active"] = false;
                    obj_val["isOut"] = false;
                    let item_inStock = null;
                    if(detail.data.attribute_values.length == 1){
                        obj_val["isOut"] = true;
                        item_inStock = detail?.data.product_details.find((x:any) => x.attribute_values.includes(obj_val.id) && x.amount > 0);
                    }
                    if(item_active_id && item_active_id.attribute_values.includes(obj_val.id) || item_inStock){
                        if(flag == false){
                            obj_val["active"] = true;
                            product_detail = { ...item_active_id, name: item_active_id.name, is_product: detail?.data?.is_product ?? true };
                        }
                        flag = true;
                        obj_val["isOut"] = false;
                    }
                    
                    // detail?.data.product_details.map((item: any) => {
                    //     //count giá trị cho input
                    //     if(arr_active_id.includes(obj_val.id) && item.amount > 0){
                    //         console.log("item active: ", item);
                    //         if(flag == false){
                    //             obj_val["active"] = true;
                    //             product_detail = { ...item, name: item.name, is_product: detail?.data?.is_product ?? true };
                    //         }
                    //         flag = true;
                    //         obj_val["isOut"] = false;
                    //     }
                    //     return item;
                    // })
                    return obj_val;
                });
                return obj;
                // return obj.values.map((obj_val:any, ix:any) => {
                //     obj_val["active"] = false;
                //     if(product_detail.attribute_values?.includes(obj_val.id)){
                //         obj_val["active"] = true;
                //     }
                //     return obj_val;
                // });
            })
        } 

        if (detail.data?.is_product === false) {
            accessories = detail.data?.product_details?.map((item: any) => {
                //count giá trị cho input
                item.count = item.product_amount ?? 0;
                return item;
            }) ?? [];
            product_detail = { ...product_detail, allowed_sell: detail.data?.allowed_sell, id: detail.data?.id, 
                temp_code: product_detail.code, code: detail.data?.code, accessories: accessories, is_product: false, 
                name: detail.data?.name, rental_price: detail.data?.rental_price, price: detail.data?.price, 
                origin_rental_price: detail.data?.origin_rental_price, origin_price: detail.data?.origin_price }
        } else {
            accessories = handleAccessories(product_detail) ?? [];
        }
        let totalAmount = detail.data.is_product === false ? (detail.data.amount > 0 ? 1 : 1) : (checkAvailableTotalAmount(product_detail) ? 1 : 1);
        let amount = (detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber(product_detail?.amount));
        await setDetail({
            ...detail,
            selectProductDetail: product_detail,
            accessories: accessories,
            attributeValues: arr_attr,
            totalAmount: totalAmount
        });
        // let _file = (detail.data.files && detail.data.files.length >0 ? detail.data.files[0] : null)
        // if(seo && _file){
        //     _setSeo({
        //         ...seo,
        //         // file: {
        //         //     file_url: environment.baseImageUrl + _file.file_url,
        //         //     file_type: _file.file_type,
        //         //     alt: _file.alt,
        //         // },
        //         product: {
        //             ...seo.product,
        //             availability: totalAmount > 0
        //         }
        //     });
        // }
        await setLoadingStock(false);
        gSnippetLoad(detail, amount);
        await getCombo(_detail);
    }

    async function loadSimilar(is_product:any, id:any, group_id:any, detail_id:any){
        let resSimilarItem: any = [];
        if(is_product === false){
            resSimilarItem = await getProductList(`limit=8&page=1`, {
                product_mix_id: id
            });
        }else{
            resSimilarItem = await getProductList(`limit=8&page=1`, {
                group_id: group_id,
                product_detail_id: detail_id
            });
        }
        
        if (resSimilarItem) {
            await setSimilarItems(resSimilarItem?.results)
        }
        setLoadingEnd(false);
    }

    function checkAvailableTotalAmount(selectProductDetail: any) {
        let isAvailabel = true;
        if (selectProductDetail) {
            if (selectProductDetail?.is_set === false) {
                if (selectProductDetail?.amount <= 0) {
                    isAvailabel = false
                }
            } else {
                selectProductDetail?.accessories?.map((item: any) => {
                    if (item.amount < 1) {
                        isAvailabel = false
                    }
                    return item;
                });
            }
        } else {
            isAvailabel = false
        }

        return isAvailabel;
    }

    function handleChangeActiveAttributeValue(parent_id: number, id: number, attributeValues?:any) {
        //=== Xử lý active Thuộc tính được chọn và thuộc tính đã chọn
        setLoading(true);
        let arr_id_attr_choose:any = [];
        
        if(attributeValues){
            detail.attributeValues = attributeValues;
            attributeValues.map((attr:any) => {
                attr.values.map((obj_val:any, ix:any) => {
                    if(obj_val["active"] == true){
                        arr_id_attr_choose.push(obj_val.id);
                    }
                    return obj_val;
                });
            });
        }else{
            arr_id_attr_choose = [id];
            detail?.attributeValues.map((attr:any) => {
                if(attr.id === parent_id){
                    attr.values.map((obj_val:any, ix:any) => {
                        obj_val["active"] = false;
                        if(obj_val.id === id){
                            obj_val["active"] = true;
                        }
                        return obj_val;
                    });
                }else{
                    attr.values.map((obj_val:any, ix:any) => {
                        if(obj_val["active"] == true){
                            arr_id_attr_choose.push(obj_val.id);
                        }
                        return obj_val;
                    });
                }
                return attr;
            });
        }
        for (let i = 0; i < (detail?.data?.product_details.length ?? 0); i++) {
            let temp = detail?.data?.product_details[i].attribute_values.some((x:any) => arr_id_attr_choose.includes(x));
            if(detail?.attributeValues.length > 1){
                temp = (arr_id_attr_choose.sort().toString() == detail?.data?.product_details[i].attribute_values.sort().toString());
            }
            if (temp) {
                let totalAmount = hasToIncreaseTotalAmount({
                    ...detail,
                    selectProductDetail: { ...detail?.data?.product_details[i], is_product: detail?.data.is_product ?? true },
                    accessories: handleAccessories(detail?.data?.product_details[i])
                }, handleAccessories(detail?.data?.product_details[i])) ?? 0;
                setDetail({
                    ...detail,
                    selectProductDetail: { ...detail?.data?.product_details[i], is_product: detail?.data.is_product ?? true },
                    accessories: handleAccessories(detail?.data?.product_details[i]),
                    totalAmount: totalAmount === Infinity ? (detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber({ ...detail?.data?.product_details[i], is_product: detail?.data.is_product ?? true }?.amount)) > 0 ? 1 : 0 : totalAmount
                })
                setLoading(false);
                return;
            }
        }
        setLoading(false);
    }

    function onChangeTotalAmount(value: number) {
        let cloneAccessories = JSON.parse(JSON.stringify(detail.accessories));
        let isInValid = false;
        if (
            value > detail.totalAmount

        ) {
            let diff = value - detail.totalAmount;
            if (detail?.selectProductDetail?.is_set === false) {
                if (detail?.data?.is_product === false) {
                    cloneAccessories = cloneAccessories?.map((e: any) => {
                        e.count += diff;
                        if (detail?.data?.is_product === false) {
                            e.count = value * e.product_amount;
                        }
                        if (e.count > e.amount) {
                            isInValid = true;
                        }
                        if (e.count < 0) {
                            e.count = 0;
                        }
                        return e;
                    })
                }
            } else {
                cloneAccessories = cloneAccessories?.map((e: any) => {
                    e.count += diff;
                    if (detail?.data?.is_product === false) {
                        e.count = value * e.product_amount;
                    }
                    if (e.count > e.amount) {
                        isInValid = true;
                    }
                    if (e.count < 0) {
                        e.count = 0;
                    }
                    return e;
                })
            }

        } else {
            let diff = detail.totalAmount - value;
            if (detail?.selectProductDetail?.is_set === false) {
                if (detail?.data?.is_product === false) {
                    cloneAccessories = cloneAccessories?.map((e: any) => {
                        e.count += diff;
                        if (detail?.data?.is_product === false) {
                            e.count = value * e.product_amount;
                        }
                        if (e.count > e.amount) {
                            isInValid = true;
                        }
                        if (e.count < 0) {
                            e.count = 0;
                        }
                        return e;
                    })
                }
            } else {
                cloneAccessories = cloneAccessories?.map((e: any) => {
                    e.count -= diff;
                    if (detail?.data?.is_product === false) {
                        e.count = value * e.product_amount;
                    }
                    if (e.count < 0) {
                        e.count = 0;
                    }
                    if (e.count > e.amount) {
                        isInValid = true;
                    }
                    return e;
                })
            }
        }
        if (isInValid) {
            setIsAllowAction(false);
            setIsAllowActionRent(false);
            toast.error("Số lượng của món đồ không khả dụng")
            return false;
        }else{
            setIsAllowAction(true);
            setIsAllowActionRent(true);
            setDetail({
                ...detail,
                totalAmount: value,
                accessories: cloneAccessories
            })
        }
        
    }

    function onChangeAccessorieAmount(value: number, id: number) {
        let cloneAccessories = [...detail.accessories]?.map((e: any) => {
            if (e.id === id) {
                e.count = value;
            }
            return e;
        });
        let totalAmount = hasToIncreaseTotalAmount(detail, cloneAccessories);

        setDetail({
            ...detail,
            accessories: cloneAccessories,
            totalAmount: totalAmount
        })
    }

    async function calcSurchargeDate(takeDate: any, returnDate: any) {
        takeDate = takeDate ?? date?.takeDate;
        returnDate = returnDate ?? date?.returnDate;
        if (takeDate === null || returnDate === null) {
            return
        }
        // let return_date = moment(returnDate).format("YYYY-MM-DD");
        // let inholiday = 0;
        // let cloneTakeDay = moment(takeDate);

        // while (cloneTakeDay.isBefore(moment(returnDate), 'day')) {
        //     if (new Date(cloneTakeDay.format("YYYY-MM-DD")).getDay() === 0 || new Date(cloneTakeDay.format("YYYY-MM-DD")).getDay() === 4) {
        //         inholiday += 1;
        //     }
        //     cloneTakeDay.add(1, 'days');
        // }
        // for (let index = 0; index < holidays.length; index++) {
        //     let el = holidays[index];
        //     if (new Date(return_date) >= new Date(el.start_date) && new Date(return_date) >= new Date(el.end_date)) {
        //         inholiday += diffInDay(new Date(el.start_date), new Date(el.end_date)) + 1
        //         break;
        //     }
        // }

        // let diff = diffInDay(new Date(moment(takeDate).format("YYYY-MM-DD")), new Date(moment(returnDate).format("YYYY-MM-DD"))) + 1 - checkUndefinedNumber(detail?.data?.time_rent_package) - inholiday;

        let diff = calSurchargeDay(workingDay, holidays, takeDate, returnDate, detail?.data?.time_rent_package) ?? 0;

        if (diff < 0) {
            setDetail({
                ...detail,
                surchargeDate: 0
            });
        } else {
            setDetail({
                ...detail,
                surchargeDate: diff
            });
        }
    }

    function groupEveryTwoItems(array: Array<any>) {
        let addArr: Array<any> = [];
        let arr: Array<any> = [];

        for (let index = 0; index < array.length; index++) {
            let num = index === 0 ? 0 : index + 1;
            let chunk = [...array].slice(num, num + 2);


            chunk = chunk?.filter(element => !addArr.includes(element));

            if (chunk.length > 0) {
                addArr = addArr.concat(chunk);
                arr.push(chunk);
            }
        }

        return arr;
    }

    // function setId() {
    //     try {
    //         setAdditional({
    //             id: JSON.parse(localStorage.getItem(constant.product) ?? "").id,
    //             name: JSON.parse(localStorage.getItem(constant.product) ?? "").name,
    //             groupName: localStorage.getItem(constant.groupName) ?? ""
    //         })
    //     } catch (error) {

    //     }

    // }
    function checkAllowActionSell() {
        let isAllow = false;
        let amount = detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber(detail?.selectProductDetail?.amount);
        // if (detail?.selectProductDetail?.accessories.length > 0) {
        //     console.log(amount);
        //     for (let index = 0; index < detail?.selectProductDetail?.accessories.length; index++) {
        //         const access = detail?.selectProductDetail?.accessories[index];

        //         if (access.count > 0) {
        //             isAllow = true;
        //         }
        //     }
        //     if (detail?.totalAmount == 0) {
        //         isAllow = false
        //     }
        // } else {
        //     isAllow = detail?.totalAmount <= amount;
        //     if (detail?.totalAmount == 0) {
        //         isAllow = false
        //     }

        // }
        isAllow = detail?.totalAmount <= amount;
        if (detail?.totalAmount == 0) {
            isAllow = false
        }

        setIsAllowAction(isAllow);
        return isAllow;
    }

    function checkAllowActionRent() {
        let isAllow = false;
        let amount = detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber(detail?.selectProductDetail?.amount);
        // if (detail?.selectProductDetail?.accessories.length > 0) {

        //     for (let index = 0; index < detail?.selectProductDetail?.accessories.length; index++) {
        //         const access = detail?.selectProductDetail?.accessories[index];

        //         if (access.count > 0) {
        //             isAllow = true;
        //         }
        //     }
        // } else {
        //     isAllow = detail?.totalAmount <= detail?.selectProductDetail?.amount;
        //     if (detail?.totalAmount == 0) {
        //         isAllow = false
        //     }
        // }
        isAllow = detail?.totalAmount <= amount;
        if (detail?.totalAmount == 0) {
            isAllow = false
        }
        if (isAllow == true) {
            if (date && date.takeDate && date.returnDate) {
                if (date.takeDate < date.returnDate) {
                    isAllow = true
                } else {
                    isAllow = false
                }
            }
            else {
                isAllow = false
            }
        }
        setIsAllowActionRent(isAllow);
        return isAllow;
    }

    useEffect(() => {
        let cloneCount = count;
        setCount(cloneCount += 1)
        //==== Không hiểu tại sao phải getRefreshStocking khi count >=2
        // if (count >= 2) {
        //     getRefreshStocking();
        // }

    }, [detail?.totalAmount])
    const rightProductRef:any = useRef(null);
    const [heightRight, setHeightRight] = useState("100%");

    useEffect(() => {
        //setId();
        // loadProductDetail();
        let isMob = (window.innerWidth < 700);
        setIsMobile(isMob);
        // setHost(window.location.origin);
        
        
        //getRefreshStocking();
    }, []);


    useEffect(() => {
        loadProductDetail();
    }, [url]);

    useEffect(() => {
        setUrl(window?.location?.pathname ?? "");
    }, [router])

    useEffect(() => {
        if (detail?.data?.is_product === true && date.takeDate && date.returnDate) {
            // if(isSeeCombo)
            getRefreshStocking();
        }
        if (detail?.data?.is_product === false && date.takeDate && date.returnDate) {
            callUpdatePrice(detail?.accessories, date)
        }
    }, [date.takeDate && date.returnDate]);

    // useEffect(() => {
    //     setStockBranch(branchs);
    // }, [branchs]);

    useEffect(() => {
        if (detail?.data?.youtube_url) {
            setActiveImage(-1);
        }
        // let doc = document.getElementById("form_in_modal_group_content_rte-edit-view");

        // if (doc) {
        //     doc.innerHTML = detail?.data?.content ?? " ";
        // }
        
                        

        // if (doc && (!doc.innerText || doc.innerText.trim() === "")) {
        //     if (detail?.data?.content.indexOf("<img") < 0) {
        //         setHasInnerText(false);
        //     }
        // }
        // checkAllowActionSell();
        // checkAllowActionRent()
    }, [detail?.data?.youtube_url]);

    useEffect(() => {
        checkAllowActionSell();
        checkAllowActionRent();

    }, [detail?.selectProductDetail && detail.totalAmount]);

    // useEffect(() => {
    //     if (detail?.selectProductDetail.code) {
    //         setStockBranch(branchs);
    //         let timer = 3000;
    //         if (detail?.data?.is_product !== false) {
    //             setTimeout(function(){
    //                 getInventory();
    //             }, 1000);
    //             // setTimeout(function(){
    //             //     getCombo(true);
    //             // }, timer);
    //         }
    //         // setTimeout(function(){
    //         //     getCombo(false);
    //         // }, timer);
    //     }
    // }, [detail?.selectProductDetail.code])

    useEffect(() => {
        if (detail?.selectProductDetail && detail?.is_product == true) {
            let totalAmount = 0;
            if (detail?.selectProductDetail.amount > 0) {
                if (detail.totalAmount === 0) {
                    totalAmount = 1;
                }
            } else {
                totalAmount = 0;
            }
            setDetail({
                ...detail,
                totalAmount: totalAmount
            })
        }
        
    }, [detail?.selectProductDetail?.id])

    // const loadToolKit = () => {
    //     let temp:any = [];
    //     if(isSeeAttach){
    //         temp.push(<DynamicAttachedItem
    //                 isAllowActionRent={(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell)}
    //                 take_date={date?.takeDate} return_date={date?.returnDate} main_id={detail?.selectProductDetail?.id}
    //                 is_product={detail?.data?.is_product}
    //                 is_combo={false}
    //                 top={"top-[107px] lg:top-[80px]"}
    //                 code={detail?.data?.is_product === true ? detail?.selectProductDetail?.code : detail?.data?.code}
    //             />);
    //     }
    //     if(detail?.data?.is_product === true && isSeeCombo){
    //         temp.push(<DynamicAttachedItem
    //         isAllowActionRent={(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell)}
    //         take_date={date?.takeDate}
    //         return_date={date?.returnDate}
    //         main_id={detail?.selectProductDetail?.id}
    //         code={detail?.selectProductDetail?.code}
    //         is_product={detail?.data?.is_product}
    //         is_combo={true} top={"top-[160px]"} />)
    //     }
    //     return (temp);
    // }

    const settingsProduct = {
        dots: false,
        infinite: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        id:"wrap-img-primary"

    };

    const [settingsAttached, setSettingsAttached]:any = useState(null);

    useLayoutEffect(() => {
    if(!loading && rightProductRef.current){
        if(isMobile){
            setHeightRight("100%");
        }else{
            setHeightRight((window.innerHeight-98) + "px");
        }
    }
        
    }, [loading, rightProductRef.current]);

    
    function reloadHeightDetail(isVideo:boolean = false){
        if (!isMobile && !loading && imgRef.current) {
            // let img_primary = document.getElementById("img_primary");
            // console.log("h_img_primary: ", img.naturalHeight);
            let wrap_left_img = document.getElementById("wrap_left_img");
            if(imgRef.current.offsetHeight && wrap_left_img){
                let h = (isVideo ? 716 : imgRef.current.offsetHeight);
                wrap_left_img.style.cssText = "height: " + h + "px";
            }
        }
    }

    function scrollTabShop(){
        setTimeout(function(){
            var scrollDiv = document.getElementById("tab_shop")?.offsetTop;
            if(scrollDiv){
                let scroll = (isMobile ? scrollDiv + 475 : scrollDiv - 50);
                //- Nếu là Mobile cần + thêm chiều cao của khung button là 230 và 220 là gần 1 nữa khung chứa ds chi nhánh
                window.scrollTo({ top: scroll, behavior: 'smooth'});
            }
                
        }, 300)
    }
    const [onPlay, setOnPlay] = useState(false);

    return (
        <>
            <>
                <DynamicHeadComponent gSnippet={gSnippet} seo={seo}/>
                <DynamicLayoutComponent isLoading={loading} loadingEnd={loadingEnd} isDetailPage={true}>
                    {!loading && <>
                        <div className="body_padding product flex flex-col">
                            <div className="relative product_detail flex h-auto flex-col lg:flex-row ">
                                {/* MAIN IMAGE MOBILE */}
                                {
                                    isMobile && 
                                    <Slider {...settingsProduct} autoplay={false}>
                                            {thumbnailVideo ? 
                                                <div className='relative lg:hidden px-4 mt-4 md:h-[800px] rounded-lg overflow-hidden flex justify-center'>
                                                    <div className="flex lg:hidden number_cart z-[2] right-[20px]">
                                                        Mã: {detail?.data?.is_product === true ? detail?.selectProductDetail?.product_code : detail?.data?.product_code}
                                                    </div>
                                                    <VideoPlayer onReady={() => {
                                                                        loadStock(detail)
                                                                    }} autoPlay={false} muted={true} key={"video"} 
                                                        url_thumbnail={thumbnailVideo?.default}
                                                        className={'relative rounded-lg overflow-hidden flex justify-center object-cover' }
                                                        url={detail?.data?.youtube_url ?? ""} 
                                                        height={thumbnailVideo.heightDefault}/>
                                                </div> : null
                                            }
                                            {detail?.data?.files?.map((item: any, index: number) => {
                                                return <div key={item.id} className='relative lg:hidden px-4 mt-4 md:h-[800px] rounded-lg overflow-hidden flex justify-center'>
                                                    <div className="flex lg:hidden number_cart z-[2] right-[20px]">
                                                        Mã: {detail?.data?.is_product === true ? detail?.selectProductDetail?.product_code : detail?.data?.product_code}
                                                    </div>
                                                    <Image
                                                        className='relative w-full rounded-[8px]'
                                                        loader={imageLoader}
                                                        src={item?.file_url ? environment.baseImageUrl + addKeyToImage(item?.file_url, 0, false, true, false, false) : "/asset/image/No_Image_Available_1.webp"}
                                                        alt={imageAlt(item?.alt, detail?.data?.name)}
                                                        title={imageAlt(item?.alt, detail?.data?.name)}
                                                        loading={'eager'}
                                                        priority
                                                        width={470}
                                                        height={641}
                                                        onLoadingComplete={() =>{
                                                                if(!detail?.data?.youtube_url && index == 0)
                                                                    loadStock(detail)
                                                            }
                                                        }
                                                        // onError={(e:any)=>{e.target.onError = null; e.target.src = "/asset/image/No_Image_Available_1.webp"}}
                                                    />
                                                </div>
                                            })
                                            }
                                    </Slider>
                                }
                                
                                
                                {/* DESKTOP IMAGE */}
                                <div className="lg:w-[52%]">
                                    <div id='left' className='w-full hidden lg:flex justify-center py-[1.5rem] flex-col'>
                                        <div id='wrap_left_img' className="lg:flex flex-row-reverse mb-3">
                                            <div id='wrap-img-primary' className='overflow-hidden relative w-full flex justify-center items-baseline'>
                                                <div className={"number_cart z-[4] " + (activeImage === -1 ? "right-[12px]" : "right-[20px]")}>
                                                    Mã: {detail?.data?.is_product === true ? detail?.selectProductDetail?.product_code : detail?.data?.product_code}
                                                </div>
                                                {activeImage === -1 ?
                                                    <div ref={imgRef} id="img_primary" className="w-full">
                                                        <VideoPlayer onReady={() => {
                                                            reloadHeightDetail(true)
                                                        }} 
                                                        url_thumbnail={thumbnailVideo?.default}
                                                        autoPlay={onPlay} muted={true} key={"-1"} 
                                                        className='grid px-[0.5rem] w-full rounded-[8px] overflow-hidden' 
                                                        url={detail?.data?.youtube_url ?? ""} 
                                                        height={thumbnailVideo.heightDefault}/>
                                                    </div>
                                                    : 
                                                    <img
                                                        id="img_primary"
                                                        className=''
                                                        src={detail?.data?.files && detail?.data?.files[activeImage]?.file_url ? environment.baseImageUrl + addKeyToImage(detail?.data?.files[activeImage]?.file_url, 0, true, false, false, false) : "/asset/image/No_Image_Available_1.webp"}
                                                        alt={imageAlt(detail?.data?.files[activeImage]?.alt, detail?.data?.name)}
                                                        title={imageAlt(detail?.data?.files[activeImage]?.alt, detail?.data?.name)}
                                                        width="530px"
                                                        loading={'eager'}
                                                        ref={imgRef}
                                                        fetchPriority="high"
                                                        onLoad={() => {
                                                            reloadHeightDetail(false)
                                                        }}
                                                        // onError={(e:any)=>{e.target.onError = null; e.target.src = "/asset/image/No_Image_Available_1.webp"}}
                                                        //objectFit='contain'
                                                    />
                                                    
                                                    // <Image
                                                    //     id="img_primary"
                                                    //     priority={true}
                                                    //     loader={imageLoader}
                                                    //     src={detail?.data?.files && detail?.data?.files[activeImage]?.file_url ? environment.baseImageUrl + addKeyToImage(detail?.data?.files[activeImage]?.file_url, 0, true, false, false, false) : "/asset/image/No_Image_Available_1.webp"}
                                                    //     alt={imageAlt(detail?.data?.files[activeImage]?.alt, detail?.data?.name)}
                                                    //     title={imageAlt(detail?.data?.files[activeImage]?.alt, detail?.data?.name)}
                                                    //     fill
                                                    //     loading={'eager'}
                                                    //     ref={imgRef}
                                                    //     sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                                    // />
                                                }
                                            </div>
                                            <div id="wrap_thumbnail">
                                                {thumbnailVideo && <div
                                                    key={-1}
                                                    onClick={() => {
                                                        setOnPlay(true);
                                                        setTimeout(function(){
                                                            setActiveImage(-1)
                                                            reloadHeightDetail(true);
                                                        }, 200);
                                                        
                                                    }}
                                                    className={`item-thumbnail thumbnail-video
                                                            ${activeImage === -1 ? "border-[1px] border-[#1890FF]" : ""}`}>
                                                    <Image
                                                        className={`relative h-full rounded-[8px]`}
                                                        src={thumbnailVideo?.min}
                                                        alt={detail?.data?.name}
                                                        title={detail?.data?.name}
                                                        layout='fill'
                                                        objectFit='cover'
                                                    />
                                                    <div className="wrap-thumbnail-video-left">
                                                        <Image
                                                            className=''
                                                            src={"/asset/icon/loading_video.gif"}
                                                            alt="g"
                                                            width={44}
                                                            height={44}
                                                        />
                                                    </div>
                                                    

                                                </div>}
                                                {
                                                    detail?.data?.files && detail?.data?.files?.map((item: any, index: number) => {
                                                        return <div
                                                            key={item.id}
                                                            onClick={() => {
                                                                setActiveImage(index);
                                                                reloadHeightDetail(false)
                                                            }}
                                                            className={`item-thumbnail`}>
                                                            <Image
                                                                className={`relative h-full rounded-[8px] ${activeImage === index ? "border-[1px] border-[#1890FF]" : ""}`}
                                                                src={item && item?.file_url ? environment.baseImageUrl + addKeyToImage(item?.file_url, windowWidth, false, false, true) : "/asset/image/No_Image_Available_1.webp"}
                                                                alt={imageAlt(item?.alt, detail?.data?.name)}
                                                                title={imageAlt(item?.alt, detail?.data?.name)}
                                                                layout='fill'
                                                                objectFit='cover'
                                                                // onError={(e:any)=>{e.target.onError = null; e.target.src = "/asset/image/No_Image_Available_1.webp"}}
                                                            />
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {/* <div id='form_in_modal_group_content_rte-edit-view' className='flex-1 h-[200px] overflow-y-auto mt-8 mb-6 mx-6 '>

                                            </div> */}
                                        </div>
                                        
                                        {
                                            detail?.data?.additional_information &&
                                            <div className="flex flex-col red-box mr-[1rem]">
                                                <div className=''>
                                                    <div className='flex flex-col'>
                                                        <DynamicDescriptionTab content={detail?.data?.additional_information ?? ""} className={"p-0"} hidden={false}/>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {!isMobile && !loadingAttached  && detail && 
                                        <Information_Product_Tab detailSP={detail} settingsAttached={settingsAttached} attachItems={attachItems} 
                                        isMobile={isMobile} router={router} setOpenSignUp={setOpenSignUp} openSellPopup={openSellPopup} 
                                        openRentPopup={openRentPopup} openOrderTrialPopup={openOrderTrialPopup} />}
                                        
                                    </div>
                                </div>
                                {
                                    !loadingStock && 
                                    <div id='right_product' className=' lg:w-[48%] flex flex-col pl-3 lg:pl-[1rem]'>
                                        <div ref={rightProductRef} id='right_sticky_product' className="sticky relative w-full  mt-[1.5rem]" style={{ height: `${heightRight}`}}>
                                            <div>
                                                <div className='flex flex-col product-right-shadow'>
                                                    <div className=' flex flex-col gap-[12px]'>
                                                        <div id="breadcrumb" className='items-center flex gap-[12px] flex-wrap'>
                                                            <Link
                                                                //href={host + "/"} 
                                                                href={"/"}
                                                                className='text-sm text-[#6E87AA] '>Trang chủ</Link>
                                                            <Image
                                                                src={"/asset/icon/ico_arrow_right_cur.svg"}
                                                                alt="->"
                                                                width={12}
                                                                height={12}
                                                            />
                                                            <Link
                                                                //href={host + "/"} 
                                                                href={'/san-pham'}
                                                                className='text-sm text-[#6E87AA] '>Sản phẩm</Link>
                                                            <Image
                                                                src={"/asset/icon/ico_arrow_right_cur.svg"}
                                                                alt="->"
                                                                width={12}
                                                                height={12}
                                                            />
                                                            {
                                                                detail?.data?.group_url?.map((e: any, index: number) => {
                                                                    return <div key={e.id} className='flex items-center gap-[12px]'>
                                                                        <Link
                                                                            href={chkUrl(e?.url)}
                                                                            // href={{ pathname: '/[...group]', query: { group: e?.url.split("/").filter((e: any) => e !== '') } }}
                                                                            className='text-sm text-[#6E87AA]'>{e.name}</Link>
                                                                        {index !== detail?.data?.group_url.length - 1 && <Image
                                                                            src={"/asset/icon/ico_arrow_right_cur.svg"}
                                                                            alt="->"
                                                                            width={12}
                                                                            height={12}
                                                                        />}
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        <h1 id="product_name" className='leading-[2rem] text-[1.3rem] lg:leading-[2rem] lg:text-[1.5rem] break_2'>
                                                            {detail?.data?.name ?? ""}
                                                        </h1>
                                                        
                                                        
                                                        <DynamicAttributeValuesRender
                                                                key={"main_attr"}
                                                                isDisable={false}
                                                                handleChangeActive={handleChangeActiveAttributeValue}
                                                                attributeValues={detail?.attributeValues}
                                                                selectProductDetail={[]}
                                                                data_product={detail?.data.product_details}/>
                                                        {arr_attr_view?.length > 0 && <div className='product_detail_right--row'>
                                                        <div className=''>Thuộc tính:</div>
                                                            <div className='product_detail_right--row--boxes text-sm'>
                                                                {
                                                                    arr_attr_view.join(", ").trimEnd()
                                                                }
                                                            </div>
                                                        </div>}
                                                        <div className='flex-col lg:flex-row w-full'>
                                                            <div className='flex flex-row gap-[8px]  justify-between '>
                                                                {
                                                                    detail?.data?.size_guide?.file_url && 
                                                                    <div className='flex flex-row gap-[8px]'>
                                                                        <div className='my-auto'>
                                                                            <Image
                                                                                src={"/asset/icon/ico_ruler.svg"}
                                                                                alt="->"
                                                                                width={16}
                                                                                height={16}
                                                                            />
                                                                        </div>
                                                                        <span onClick={() => {setIsOpenSizeGuide(true)}} 
                                                                            className={'cursor-pointer underline lg:no-underline cursor-not-allowed'}>
                                                                            Hướng dẫn chọn size
                                                                        </span>
                                                                    </div>
                                                                }
                                                                
                                                            </div>
                                                        </div>
                                                        <div className="flex flex-col lg:flex-row gap-3 justify-between w-full">
                                                            <div className='product_detail_right--row'>
                                                                <span className=''>Số lượng</span>
                                                                <DynamicInputNumber
                                                                    //max={detail?.data?.is_product === false ? detail?.data?.amount : detail?.selectProductDetail?.is_set === false ? detail?.selectProductDetail?.amount : maxTotalAmount(detail, detail?.accessories)}
                                                                    key={"totalAmount"}
                                                                    value={detail?.totalAmount}
                                                                    onChange={onChangeTotalAmount} />
                                                                {(detail?.selectProductDetail?.is_set === false || detail?.data?.is_product === false) && 
                                                                <span className=''>
                                                                    Còn lại trong kho: {detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber(detail?.selectProductDetail?.amount)}
                                                                    {
                                                                        detail?.data?.is_product == true && <a className="aActive items-center flex" onClick={()=>{
                                                                            setActiveTabShop(activeTabShop + 1);
                                                                            scrollTabShop();
                                                                        }}>Xem chi nhánh có hàng</a>
                                                                    }
                                                                </span>}
                                                            </div>
                                                            
                                                        </div>

                                                        <div className='flex gap-4 lg:gap-12 flex-col lg:flex-row mb-[12px]'>
                                                            {detail?.selectProductDetail?.allowed_sell === true && detail?.selectProductDetail?.rental_price ? <div className='flex flex-row items-center gap-3'>
                                                                <span className=' '>
                                                                    Giá thuê: 
                                                                </span>
                                                                <span className='lbl-price'>
                                                                    {detail?.selectProductDetail?.rental_price ? currencyWithNoFormat(detail?.selectProductDetail?.rental_price) : ""}
                                                                    {detail?.data.include_vat ? '*': <></>}
                                                                </span>
                                                                {
                                                                    detail?.selectProductDetail?.origin_rental_price && (detail?.selectProductDetail?.origin_rental_price != detail?.selectProductDetail?.rental_price) &&
                                                                    <span className='lbl-price lbl-price-thr'>{currencyWithNoFormat(detail?.selectProductDetail?.origin_rental_price)}</span>
                                                                }
                                                                
                                                            </div> : ""}
                                                            <div className='flex flex-row items-center gap-3'>
                                                                <span className=''>
                                                                    Giá bán: 
                                                                </span>
                                                                <span className='lbl-price'>
                                                                    {detail?.selectProductDetail?.price ? currencyWithNoFormat(detail?.selectProductDetail?.price) : ""}
                                                                    {detail?.data.include_vat ? '*': <></>}
                                                                </span>
                                                                {
                                                                    detail?.selectProductDetail?.origin_price && (detail?.selectProductDetail?.origin_price != detail?.selectProductDetail?.price) &&
                                                                    <span className='lbl-price lbl-price-thr'>{currencyWithNoFormat(detail?.selectProductDetail?.origin_price)}</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                {detail && <Tab detailSP={detail} activeTabShop={activeTabShop} date={date} moment={moment} loadingStock={loadingStock}
                                                                                    onChangeAccessorieAmount={onChangeAccessorieAmount} onChangeAttribute={onChangeAttribute} />}
                                                {/* <div className='product_detail_right_middle'>
                                                    {loading == false && activeTab == -1 ? <RenderTab key="renderTab" detail={detail} activeTab={activeTab} /> : <></>}
                                                </div> */}
                                                {/* Thông tin/banner giảm giá */}
                                                {
                                                    (detail?.data.is_product === true && detail?.selectProductDetail?.keywords.length > 0) 
                                                        && <DynamicList_keyword keywordData={detail?.selectProductDetail?.keywords} className={"mt-3"} />
                                                    ||
                                                    (detail?.data.is_product === false && detail?.data?.keywords.length > 0) 
                                                        && <DynamicList_keyword keywordData={detail?.data?.keywords} className={"mt-3"} />
                                                    
                                                }
                                            </div>
                                            
                                            <div className="wrap-product-button-bottom hidden lg:block">
                                                <div className='wrap-product-layout-rent '>
                                                    {detail?.selectProductDetail?.allowed_sell && <div className='product-rent_sell_day'>
                                                        {/* <span className='text-[#434343] text-sm'>Ngày lấy và ngày trả</span> */}
                                                        <div className='flex flex-row gap-2'>
                                                            <DatePicker
                                                                key={"takeDate"}
                                                                status={date ? date.takeDate > date.returnDate ? "error" : "" : ""}
                                                                disabledDate={(current) => {
                                                                    return current && current < moment().startOf('day');
                                                                }}
                                                                className='text-sm'
                                                                defaultValue={date?.takeDate ? dayjs(date?.takeDate) : undefined}
                                                                onChange={async (e: any) => {
                                                                    await calcSurchargeDate(new Date(e), null)
                                                                    await setDate({
                                                                        ...date,
                                                                        takeDate: new Date(e)
                                                                    });


                                                                }}
                                                                placeholder="Ngày lấy" />
                                                            <DatePicker
                                                                key={"returnDate"}
                                                                status={date ? date.takeDate > date.returnDate ? "error" : "" : ""}
                                                                disabledDate={(current) => {
                                                                    return current && current < moment().startOf('day');
                                                                }}
                                                                className='text-sm'
                                                                defaultValue={date?.returnDate ? dayjs(date?.returnDate) : undefined}
                                                                onChange={async (e: any) => {
                                                                    await calcSurchargeDate(null, new Date(e));
                                                                    await setDate({
                                                                        ...date,
                                                                        returnDate: new Date(e)
                                                                    })

                                                                }}
                                                                placeholder="Ngày trả" />
                                                        </div>
                                                        <div className='flex text-base text-red-500'>
                                                            {date ? date.takeDate > date.returnDate ? "Ngày lấy phải bé hơn ngày trả" : "" : ""}
                                                        </div>
                                                    </div>}
                                                    {/* <Link target='_blank' rel="noopener noreferrer" href={host + pathRouter.GOITHUE} className='product--rent_package'>
                                                        <Image
                                                            src={"/asset/icon/ico_product_notice.svg"}
                                                            alt="->"
                                                            width={16}
                                                            height={16}
                                                        />
                                                        <span className='text-[#434343] text-sm'>Gói thuê</span>
                                                    </Link> */}
                                                    {
                                                        (detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell) && 
                                                        <div 
                                                            // href={'/quy-dinh-thue.html'}
                                                            onClick={() => {setIsRentRule(true)}} 
                                                            className='product--rent_policy'>
                                                            <Image
                                                                src={"/asset/icon/ico_product_notice.svg"}
                                                                alt="->"
                                                                width={16}
                                                                height={16}
                                                            />
                                                            <span>Quy định thuê</span>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='wrap-product-button'>
                                                    {/* <div className="flex justify-between product_detail_right_bottom--content" >
                                                        <div className='flex flex-col'>
                                                            <span className='product_detail_right_bottom--sum'>Tổng tiền của bộ đồ</span>
                                                            <span className='product_detail_right_bottom--detail text-xs xl:text-sm'>(Gói thuê: {checkUndefinedNumber(detail?.data?.time_rent_package)} ngày- phụ thu: {detail?.surchargeDate} ngày)</span>
                                                            <span className='product_detail_right_bottom--rent text-sm xl:text-base font-bold'>
                                                                {
                                                                    detail?.selectProductDetail?.allowed_sell === false ? "Không cho thuê" : "Giá thuê: " + currencyFormatter.format(calcTotalRentPrice(detail))
                                                                }
                                                            </span>
                                                            <span className='product_detail_right_bottom--rent text-sm xl:text-base font-bold'>Giá bán:&nbsp;
                                                                {currencyFormatter.format(calcTotalSellPrice(detail))}
                                                            </span>
                                                        </div>
                                                    </div > */}
                                                    <div className='wrap-product-box-button' 
                                                        style={(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell) ? {gridTemplateColumns: "1fr 1fr"}: {gridTemplateColumns: "1fr"}}>
                                                        {(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell) && 
                                                        <div className={'box group ' + (!(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell) ? "cursor-not-allowed" : "cursor-pointer")}>
                                                            <span >Đặt thuê</span>
                                                            <div className='button-group-hover'>
                                                                <div onClick={() => {
                                                                    if (isAllowActionRent && handleAddToCartRent()) {
                                                                        toast.success('Trang web đang chuyển đến giỏ hàng...');
                                                                        router.push("/carts");
                                                                    }
                                                                }} 
                                                                    title={(!isAllowActionRent ? "Vui lòng chọn thời gian thuê" : "")}
                                                                    className={'btn-product-box ' + (!isAllowActionRent ? "cursor-not-allowed" : "")}>
                                                                    Thuê ngay
                                                                </div>

                                                                <button onClick={() => {
                                                                        if (isAllowActionRent) {
                                                                            handleAddToCartRent()
                                                                        }
                                                                    }} 
                                                                    title={(!isAllowActionRent ? "Vui lòng chọn thời gian thuê" : "")}
                                                                    className={'btn-product-box btn-product-box-second ' + (!isAllowActionRent ? "cursor-not-allowed" : "")}>
                                                                    Thêm vào giỏ
                                                                </button>
                                                            </div>
                                                        </div>}
                                                        <div className='box cursor-pointer group box-second'>
                                                            <span>Đặt mua</span>
                                                            <div className='button-group-hover'>
                                                                {isAllowAction ? <Link
                                                                    href={{ pathname: '/[...group]', query: { group: ['carts'] } }}
                                                                    onClick={() => {
                                                                        toast.success('Trang web đang chuyển đến giỏ hàng...');
                                                                        handleAddToCartSell()
                                                                    }} className={'btn-product-box ' + (!isAllowAction ? "cursor-not-allowed" : "")}>
                                                                    Mua ngay
                                                                </Link> :
                                                                    <div className={'btn-product-box ' + (!isAllowAction ? "cursor-not-allowed" : "")}>
                                                                        Mua ngay
                                                                    </div>}
                                                                <button onClick={() => {
                                                                    if (isAllowAction) {
                                                                        handleAddToCartSell()
                                                                    }
                                                                }} className={'btn-product-box btn-product-box-second ' + (!isAllowAction ? "cursor-not-allowed" : "")}>
                                                                    Thêm vào giỏ
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div >
                                                {
                                                    !isAllowAction && <p className='wrap-alert'>{
                                                        detail?.totalAmount === 0 ? 'Số lượng chọn phải lớn hơn 0' : 'Số lượng tồn kho không đủ.'
                                                    }</p>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                
                            </div >

                            {/* {
                                detail?.data?.content && <div className='hidden bg-[#F5F5F5] lg:flex px-2 lg:px-[44px] w-[100vw] py-2 lg:py-[44px]'>

                                </div>
                            } */}
                            
                            
                            { /*content ? <div className='flex w-full flex-col product_other' id="">
                                            <div className='wrap-title'>
                                                <div className='divider'></div>
                                                <p className='title'>Nội dung sản phẩm</p>
                                                <div className='divider'></div>
                                            </div>
                                            <div id='form_in_modal_group_content' className='bg-white richTextEditor e-control e-richtexteditor e-lib e-rte-toolbar-enabled w-full h-auto mt-0 mx-auto rounded-[8px]'>
                                                <div className='e-rte-content h-auto mt-0' id="form_in_modal_group_contentrte_view">
                                                    <div id="form_in_modal_group_content_rte-edit-view" tabIndex={0} className="e-content e-lib e-keyboard" dangerouslySetInnerHTML={{__html: content}}>
                                                        {/* {arrayProductData(typeProducts)?.find((e: any) => e.url === activeType)?.content ?? ""} }
                                                    </div>
                                                </div>
                                            </div>
                                    {/* <button id="readMore" className='btn-readmore' onClick={() => {
                                            let wrap = document.getElementById("form_in_modal_group_content");
                                            let btnMore = document.getElementById("readMore");
                                            if(wrap && btnMore){
                                                if(btnMore.innerText.toLocaleLowerCase() == "xem thêm"){
                                                    wrap.classList.add("wrap_content_mobile_full");
                                                    console.log(wrap.style);
                                                    btnMore.innerText = "Thu gọn";
                                                }else{
                                                    // wrap.style.height = "100px !important";
                                                    wrap.classList.remove("wrap_content_mobile_full");
                                                    btnMore.innerText = "Xem thêm";
                                                }
                                            }
                                        }}>Xem thêm
                                    </button> }
                                </div> : <></>
                            }
                            {/* {detail?.data?.content && <div className='px-2 py-10 lg:px-[44px] lg:pt-0 lg:pb-[44px] description_detail mx-2 lg:mx-[48px] flex flex-col justify-center items-center'>
                                <div id='description_product' className=''>

                                </div>
                            </div>} */}
                            {
                                !loadingStock && isMobile && <div>
                                    {
                                        detail?.data?.additional_information &&
                                        <div className="product_other">
                                            <div className="flex flex-col red-box mr-[1rem] ml-4">
                                                <div className=''>
                                                    <div className='flex flex-col'>
                                                        <DynamicDescriptionTab content={detail?.data?.additional_information ?? ""} className={"p-0"} hidden={false}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {
                                !loadingStock && isMobile && <div>
                                    {
                                        detail?.data?.product_information && 
                                        <div className="product_other">
                                            <div className='wrap-title1'>
                                                <p className='title'>Thông tin sản phẩm</p>
                                            </div>
                                            <div className={`bg-white richTextEditor e-control e-richtexteditor e-lib e-rte-toolbar-enabled 
                                                w-full h-auto mt-0 mx-auto rounded-[8px]`}>
                                                <div className='e-rte-content h-auto mt-0' id="form_in_modal_group_contentrte_view">
                                                    <div id="form_in_modal_group_content_rte-edit-view" tabIndex={0} className="e-content e-lib e-keyboard" dangerouslySetInnerHTML={{__html: detail?.data?.product_information}}>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        detail?.data?.content && 
                                        <div className="product_other">
                                            <div className='wrap-title1'>
                                                <p className='title'>Mô tả sản phẩm</p>
                                            </div>
                                            <div className={`bg-white richTextEditor e-control e-richtexteditor e-lib e-rte-toolbar-enabled 
                                                w-full h-auto mt-0 mx-auto rounded-[8px]`}>
                                                <div className='e-rte-content h-auto mt-0' id="form_in_modal_group_contentrte_view">
                                                    <div id="form_in_modal_group_content_rte-edit-view" tabIndex={0} className="e-content e-lib e-keyboard" dangerouslySetInnerHTML={{__html: detail?.data?.content}}>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        settingsAttached && attachItems.length > 0 && 
                                        <div className="product_other">
                                            <div className='wrap-title1'>
                                                <p className='title'>Gợi ý mua kèm</p>
                                            </div>
                                            <div className={"w-full relative product-attached" }>
                                                {/* <Slider className={(isMobile && attachItems.length <= 1 ? "one-item" : "")} {...settingsAttached}> */}
                                                    {
                                                        attachItems?.map((item: any) => {
                                                            return <Item
                                                                    setUrl={() => router.reload()}
                                                                    setOpenSignUp={setOpenSignUp}
                                                                    setIdOrderTrialPopup={() => { }}
                                                                    openSellPopup={openSellPopup}
                                                                    openRentPopup={openRentPopup}
                                                                    openOrderTrialPopup={openOrderTrialPopup}
                                                                    item={item} key={item.id} />
                                                        })
                                                    }
                                                {/* </Slider>  */}
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            {/* SIMILAR PRODUCT */}
                            {!loadingStock && similarItems.length > 0 ? <div id="similar_product" className="product_other ">
                                <div className='wrap-title'>
                                    <div className='divider'></div>
                                    <p className='title'>Sản phẩm tương tự</p>
                                    <div className='divider'></div>
                                </div>
                                
                                <div className={"products mx-auto min-h-[500px] w-full"}>
                                    
                                    {/* <Slider {...settingsSimilar}> */}
                                        <div className="products_body">
                                                {
                                                    similarItems?.map((item: any) => {
                                                        return <Item
                                                                setUrl={() => router.reload()}
                                                                setOpenSignUp={setOpenSignUp}
                                                                setIdOrderTrialPopup={() => { }}
                                                                openSellPopup={openSellPopup}
                                                                openRentPopup={openRentPopup}
                                                                openOrderTrialPopup={openOrderTrialPopup}
                                                                item={item} key={item.id} />
                                                    })
                                                }
                                                </div>
                                    {/* </Slider>  */}
                                    
                                </div>
                            </div> : <></>
                            }
                        </div >

                        

                        {/* {
                            phaseMobile === IOrderType.orderCalendar &&
                            <>
                                <div
                                    className='fixed w-[100vw] h-full z-[6] top-0'
                                    onClick={() => {
                                        setPhaseMobile(-1);
                                    }}>

                                </div>
                                <div className='fixed lg:hidden bg-white w-full bottom-0 z-[25] product_detail_bar p-4 flex flex-col gap-3'>
                                    <div className='flex flex-row w-full py-4 justify-left'>
                                        <Image
                                            className='cursor-pointer'
                                            onClick={() => setPhaseMobile(-1)}
                                            src={"/asset/icon/ico_arrow_forward_ios.svg"}
                                            alt="->"
                                            width={16}
                                            height={16}
                                        />
                                    </div>
                                    <div className="flex flex-row gap-4 order_pop--form w-full pb-[5rem]">
                                        <div className="flex flex-col gap-1 flex-1">
                                            <span className="text-sm text-[#8C8C8C]">Chọn ngày thử đồ</span>
                                            <DatePicker
                                                key={"takeDate"}

                                                disabledDate={(current) => {
                                                    return current && current < moment().startOf('day');
                                                }}
                                                defaultValue={date?.takeDate ? dayjs(date?.takeDate) : undefined}
                                                onChange={async (e: any) => {
                                                    await calcSurchargeDate(new Date(e), null)
                                                    await setDate({
                                                        ...date,
                                                        takeDate: new Date(e)
                                                    });


                                                }}
                                                placeholder="Ngày lấy" />
                                        </div>
                                        <div className="flex flex-col gap-1 flex-1">
                                            <span className="text-sm text-[#8C8C8C]">Chọn chi nhánh thử đồ</span>
                                            <Select
                                                key={"takeDate"}
                                                options={branchs?.map((e: any) => {
                                                    return {
                                                        value: e.id,
                                                        label: e.name
                                                    }
                                                })}
                                                onChange={async (e: any) => {
                                                    setSelectBranch(e);
                                                }}
                                                placeholder="Chọn chi nhánh" />
                                        </div>
                                    </div>
                                </div>
                            </>

                        } */}

                        {
                            !loadingStock && <div className='fixed lg:hidden bg-white w-full bottom-0 z-[26] py-2 px-5 product_detail_bar--inner flex flex-col p-2 items-center gap-2'>
                                {
                                    (detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell) && 
                                    <div onClick={() => {setIsRentRule(true)}} 
                                        className={'wrap-rent-rule-mobile'}>
                                        <span className='underline'>Quy định thuê</span>
                                        <Image
                                            src={"/asset/icon/ico_product_notice.svg"}
                                            alt="->"
                                            width={16}
                                            height={16}
                                        />

                                    </div>
                                }
                                {
                                    phaseMobile === IOrderType.rent &&
                                    <>
                                        <div className={"flex flex-col gap-2 order_pop--form w-full"}>
                                            <div className="flex flex-col gap-3 px-4 py-3 popup_order_near_bottom_inner w-full justify-center items">
                                                <div className='flex flex-row gap-3 items-center justify-between'>
                                                    <div className='flex flex-col'>
                                                        <span className='text-sm mb-[4px]'>Số lượng</span>
                                                        <DynamicInputNumber
                                                            max={detail?.data?.is_product === false ? detail?.data?.amount : detail?.selectProductDetail?.is_set === false ? detail?.selectProductDetail?.amount : maxTotalAmount(detail, detail?.accessories)}
                                                            key={"totalAmount"}
                                                            value={detail?.totalAmount}
                                                            onChange={onChangeTotalAmount} />
                                                    </div>
                                                    <div className='flex flex-col'>
                                                        <span className="text-sm mb-[4px]">Chọn thời gian thuê</span>
                                                        <div className="flex flex-row gap-4 w-full h-[38px]">
                                                            <DatePicker
                                                                inputReadOnly={true} 
                                                                className='flex-1'
                                                                key={"takeDate"}
                                                                format={"DD-MM-YY"}
                                                                popupClassName="custom-picker-popup" 
                                                                status={date ? date.takeDate > date.returnDate ? "error" : "" : ""}
                                                                disabledDate={(current) => {
                                                                    return current && current < moment().startOf('day');
                                                                }}
                                                                defaultValue={date?.takeDate ? dayjs(date?.takeDate) : undefined}
                                                                onChange={async (e: any) => {
                                                                    await calcSurchargeDate(new Date(e), null)
                                                                    await setDate({
                                                                        ...date,
                                                                        takeDate: new Date(e)
                                                                    });


                                                                }}
                                                                placeholder="Ngày lấy" />
                                                            <DatePicker
                                                                inputReadOnly={true} 
                                                                className='flex-1'
                                                                format={"DD-MM-YY"}
                                                                popupClassName="custom-picker-popup" 
                                                                key={"returnDate"}
                                                                status={date ? date.takeDate > date.returnDate ? "error" : "" : ""}
                                                                disabledDate={(current) => {
                                                                    return current && current < moment().startOf('day');
                                                                }}
                                                                defaultValue={date?.returnDate ? dayjs(date?.returnDate) : undefined}
                                                                onChange={async (e: any) => {
                                                                    await calcSurchargeDate(null, new Date(e));
                                                                    await setDate({
                                                                        ...date,
                                                                        returnDate: new Date(e)
                                                                    })


                                                                }}
                                                                placeholder="Ngày trả" />
                                                        </div>
                                                    </div>
                                                </div>
                                                {detail?.selectProductDetail?.is_set === false && 
                                                    <div className='flex flex-row justify-between text-sm lg:text-base text-[#8c8c8c] '>
                                                        <span>
                                                            Còn lại trong kho:&nbsp;
                                                            <b>{detail?.data?.is_product === false ? detail?.data?.amount : checkUndefinedNumber(detail?.selectProductDetail?.amount)}</b>
                                                        </span>
                                                        <a className="aActive" onClick={()=>{
                                                            setActiveTabShop(activeTabShop + 1);
                                                            scrollTabShop();
                                                        }}>
                                                            Xem chi nhánh có hàng
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </>
                                }
                                <div className="flex flex-row w-full gap-2">
                                    {
                                        (phaseMobile === IOrderType.rent || phaseMobile === IOrderType.sell) &&
                                        <div className='wrap-back-mobile'>
                                            <Image
                                                className='cursor-pointer'
                                                onClick={() => setPhaseMobile(-1)}
                                                src={"/asset/icon/ico_arrow_forward_ios.svg"}
                                                alt="->"
                                                width={16}
                                                height={16}
                                            />
                                        </div>
                                    }
                                    <div className='flex flex-row justify-center items-center gap-2 w-full'>
                                        {phaseMobile === -1 && <>
                                            {detail?.selectProductDetail?.allowed_sell && <button
                                                onClick={() => {
                                                    if (isAllowAction) {
                                                        setPhaseMobile(IOrderType.rent)
                                                    }
                                                }}
                                                className={`btn-product-mobile 
                                                ${!isAllowAction ? ' btn-product-mobile-disable' : ""}
                                            `}
                                            >
                                                Đặt Thuê
                                            </button>}
                                            <button
                                                onClick={() => {
                                                    if (isAllowAction) {
                                                        setPhaseMobile(IOrderType.sell)
                                                    }
                                                }}
                                                className={`btn-product-mobile btn-product-mobile-second
                                                    ${!isAllowAction ? ' btn-product-mobile-disable' : ""}
                                            `}>
                                                Đặt Mua
                                            </button>
                                            {/* <button onClick={() => {
                                                onCheckAlreadySignUp()
                                                // if (onCheckAlreadySignUp() && false) {
                                                //     setPhaseMobile(IOrderType.orderCalendar)
                                                // }
                                            }}
                                                className={`
                                                ${false ? 'text-xs px-4 py-2 bg-[#006D75] text-white rounded-md h-[2.75rem]' : "text-xs px-4 py-2 bg-[#bfbfbf] text-white rounded-md h-[2.75rem]"}
                                            `}>
                                                Đặt Lịch Thử Đồ
                                            </button> */}
                                            <div className='flex lg:gap-12 flex-col lg:flex-row'>
                                                {detail?.selectProductDetail?.allowed_sell === true && detail?.selectProductDetail?.rental_price ? <div className='flex flex-row gap-3'>
                                                    <span className=''>
                                                        Thuê:
                                                    </span>
                                                    <div className="flex flex-col">
                                                        <span className='lbl-price'>
                                                            {detail?.selectProductDetail?.rental_price ? currencyWithNoFormat(detail?.selectProductDetail?.rental_price) : ""}
                                                            {detail?.data.include_vat ? '*': <></>}
                                                        </span>
                                                        {
                                                            detail?.selectProductDetail?.origin_rental_price && (detail?.selectProductDetail?.origin_rental_price != detail?.selectProductDetail?.rental_price) &&
                                                            <span className='lbl-price lbl-price-thr'>{currencyWithNoFormat(detail?.selectProductDetail?.origin_rental_price)}</span>
                                                        }
                                                    </div>
                                                </div> : ""}
                                                <div className='flex flex-row  gap-3'>
                                                    <span className=''>
                                                        Bán :
                                                    </span>
                                                    <div className="flex flex-col">
                                                        <span className='lbl-price'>
                                                            {detail?.selectProductDetail?.price ? currencyWithNoFormat(detail?.selectProductDetail?.price) : ""}
                                                            {detail?.data.include_vat ? '*': <></>}
                                                        </span>
                                                        {
                                                            detail?.selectProductDetail?.origin_price && (detail?.selectProductDetail?.origin_price != detail?.selectProductDetail?.price) &&
                                                            <span className='lbl-price lbl-price-thr'>{currencyWithNoFormat(detail?.selectProductDetail?.origin_price)}</span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                        {/* {
                                            phaseMobile === IOrderType.orderCalendar && <button onClick={() => {
                                                //onTryOnSchedule()
                                                //setOpenMaintain(true)
                                                onCheckAlreadySignUp()
                                            }} className='py-[9px] flex flex-1 items-center justify-center bg-[#006D75] text-white rounded-md mt-4 font-medium h-[2.75rem]'>Đặt lịch thử đồ</button>
                                        }
                                        */}
                                        
                                        {
                                            phaseMobile === IOrderType.rent && detail?.selectProductDetail?.allowed_sell && <>
                                                <button
                                                    className={"btn-product-mobile w-full " + (!isAllowActionRent ? "btn-product-mobile-disable" : "")}
                                                    onClick={() => {
                                                        if (isAllowActionRent) {
                                                            handleAddToCart(false)
                                                        }
                                                    }}
                                                >
                                                    Thêm vào giỏ
                                                </button>
                                                <button
                                                    className={'btn-product-mobile btn-product-mobile-second w-full ' + (!isAllowActionRent ? "btn-product-mobile-disable" : "")}
                                                    onClick={() => {
                                                        if (isAllowActionRent && handleAddToCartRent()) {
                                                            toast.success('Trang web đang chuyển đến giỏ hàng...');
                                                            router.push("/carts");
                                                        }
                                                    }}
                                                >
                                                    Thuê ngay
                                                </button>
                                                {/* <Link prefetch={false} onClick={() => {
                                                    if (isAllowActionRent) {
                                                        handleAddToCart(false)
                                                    }
                                                }} className={'btn-product-mobile btn-product-mobile-second w-full ' + (!isAllowActionRent ? "btn-product-mobile-disable" : "")}
                                                    //href={'/carts'}
                                                    href={{ pathname: '/[...group]', query: { group: ['carts'] } }}
                                                >Đặt thuê</Link> */}
                                            </>
                                        }
                                        {
                                            phaseMobile === IOrderType.sell && <>
                                                <button
                                                    className={"btn-product-mobile w-full " + (!isAllowAction ? "btn-product-mobile-disable" : "")}
                                                    onClick={() => {
                                                        if (isAllowAction) {
                                                            handleAddToCart(true)
                                                        }
                                                    }}
                                                >
                                                    Thêm vào giỏ
                                                </button>
                                                <button
                                                    className={'btn-product-mobile btn-product-mobile-second w-full ' + (!isAllowAction ? "btn-product-mobile-disable" : "")}
                                                    onClick={() => {
                                                        if (isAllowAction && handleAddToCartSell()) {
                                                            toast.success('Trang web đang chuyển đến giỏ hàng...');
                                                            router.push("/carts");
                                                        }
                                                    }}
                                                >
                                                    Mua ngay
                                                </button>
                                                {/* <Link prefetch={false} onClick={() => {
                                                    if (isAllowAction) {
                                                        handleAddToCart(true)
                                                    }
                                                }} className={'btn-product-mobile btn-product-mobile-second w-full ' + (!isAllowActionRent ? "btn-product-mobile-disable" : "")}
                                                    //href={'/carts'}
                                                    href={{ pathname: '/[...group]', query: { group: ['carts'] } }}
                                                >Đặt mua</Link> */}
                                            </>
                                        }
                                    </div>
                                </div>
                                {((!isAllowActionRent && phaseMobile === IOrderType.rent) || !isAllowAction) && 
                                <div className="text-red-600 text-sm">
                                    {
                                        !isAllowActionRent && phaseMobile === IOrderType.rent ? "Vui lòng chọn thời gian thuê" : 
                                        (!isAllowAction && detail?.totalAmount === 0) ? 'Số lượng chọn phải lớn hơn 0' :
                                        (!isAllowAction && detail?.totalAmount > 0) ? 'Số lượng tồn kho không đủ.' : ""
                                    }
                                </div>}
                        </div>
                        }
                        

                        {isOpen.id && isOpen.isOpen && <PopupOrder
                            is_purchase={isOpen.is_purchase}
                            isOpen={isOpen.isOpen}
                            setIsOpen={closePopup}
                            id={isOpen.id}
                            orderDate={isOpen.isOthers ? null : date}
                            orderType={isOpen.orderType}
                            branchs={branchs}
                            detailData={isOpen.isOthers ? null : detail}
                            is_product={isOpen.is_product} 
                            url_product={isOpen.url_product}/>}
                        {
                            isOpenSizeGuide && <PopupSizeGuide isOpen={isOpenSizeGuide} setIsOpen={() => {
                                setIsOpenSizeGuide(false)
                            }} url={detail?.data?.size_guide?.file_url} />
                        }
                        {
                            isRentRule && <PopupSizeGuide isOpen={isRentRule} setIsOpen={() => {
                                setIsRentRule(false)
                            }} url={null} isRentRule={true}/>
                        }
                        {isOpen.id && openSignUp && <PopupSignup
                            is_product={isOpen.is_product}
                            id={isOpen.id}
                            setOpen={setOpenSignUp}
                            additionalFunc={() => {
                                // if (onCheckAlreadySignUp()) {
                                //     if (isMobile) {
                                //         setPhaseMobile(IOrderType.orderCalendar);
                                //     } else {
                                //         openOrderTrialPopup(detail.selectProductDetail?.id, false, detail.selectProductDetail?.is_product);
                                //     }
                                // }
                            }} />}
                        
                        

                        {
                            openWarning == true && <DynamicPopupWarning setOpenWarning={setOpenWarning}/>
                        }
                        {/* <div className="wrap-toolkit">
                            {isSeeAttach && <DynamicAttachedItem
                                isAllowActionRent={(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell)}
                                take_date={date?.takeDate} return_date={date?.returnDate} main_id={detail?.selectProductDetail?.id}
                                is_product={detail?.data?.is_product}
                                is_combo={false}
                                top={"top-[107px] lg:top-[80px]"}
                                code={detail?.data?.is_product === true ? detail?.selectProductDetail?.code : detail?.data?.code}
                            />}
                            {detail?.data?.is_product === true && isSeeCombo && <DynamicAttachedItem
                            isAllowActionRent={(detail?.data.is_product === false ? detail?.data.allowed_sell : detail?.selectProductDetail?.allowed_sell)}
                            take_date={date?.takeDate}
                            return_date={date?.returnDate}
                            main_id={detail?.selectProductDetail?.id}
                            code={detail?.selectProductDetail?.code}
                            is_product={detail?.data?.is_product}
                            is_combo={true} top={"top-[160px]"} />}
                            <Support isDetail={true}/>
                        </div> */}

                    </>
                }
                    
                </DynamicLayoutComponent>
            </>
        </>
    )
}

export default Product;